<section id="main" class="bg-light">
     <div id="invoiceContainer" class="container">
          <h1 [innerHtml]="'InvoiceActivityHeader' | translator:'invoice'">Pay Invoice(s)</h1>
          <div class="row">
               <div id="invoiceActivityContainer" class="col-lg-12">
                    <app-activity></app-activity>
               </div>
          </div>
          <div class="row">
               <div class="col-12 col-md-6 mb-3">
                    <app-dashboardsupport class="h-100" />
               </div>
               <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <div class="card shadow-sm rounded-0 border-0 h-100">
                         <div class="card-body" >
                              <h2 class="card-title h5 mt-0" [innerHtml]="'Resources' | translator:'base'">
                                   Resources</h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')" target="_blank"
                                             class="btn btn-link"
                                             [title]="'MAHEnrollAgreement'  | translator:'base'"
                                             [innerHtml]="'MAHEnrollAgreement'  | translator:'base'"
                                             name="MAHagreement" id="MAHagreement">
                                             PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')" target="_blank"
                                             class="btn btn-link"
                                             [title]="'ISPEnrollAgreement'  | translator:'base'"
                                             [innerHtml]="'ISPEnrollAgreement'  | translator:'base'"
                                             name="ISPagreement" id="ISPagreement">
                                             PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                             [innerHtml]="'DisclosureAndAuth'  | translator:'base'"
                                             (click)="openDocument('PSPDisclosureandAuthorizationForm')" target="_blank"
                                             [title]="'DisclosureAndAuth'  | translator:'base'"
                                             name="dna" id="dna">
                                             Disclosure and Authorization Form
                                        </button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>
